import React, { useEffect } from "react";
import { useAuth } from "../../Common/Hooks/useAuth";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";

interface EnsureLoginProps {
  children: React.ReactNode;
}
export const EnsureLogin: React.FC<EnsureLoginProps> = ({ children }) => {
  const { isLoggedIn, clientUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn]);

  useEffect(() => {
    let user = null;
    if (clientUser) {
      user = { id: clientUser.id, email: clientUser.email }
    }
    Sentry.setUser(user);
  }, [clientUser]);

  return children;
};
